var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"wf-component wf-yah",on:{"click":function($event){return _vm.onClicked()}}},[_c('i',{staticClass:"wf-icon",style:({'background-image': _vm.yahLogo})}),_c('label',{attrs:{"data-translation-element":"yah"}},[_vm._v("YAH")])])
}
var staticRenderFns = []

export { render, staticRenderFns }